import * as React from 'react'
import { Interpolate } from '@doordash/lib-i18n'
import * as actions from '../../../actions'
import i18n from '../../../i18n'
import * as geCampaignType from '../../../typeModules/guaranteedEarningsCampaign'
import {
  COUNTRY_SHORTCODES,
  IOS_SIGNUP_SOURCE_PARAM,
  AWS_BASE,
} from '../../../constants'
import * as Exp from '../../../experimentConstants'
import { ValueProps } from '../../molecules/value-props'
import Simple from '../../templates/simple'
import GuaranteedEarningsRedirectModal from './components/GEModal'
import HeaderSection from './components/HeaderSection'
import SignupForm from './components/SignupForm'
import ListCell from '@doordash/component-list-cell'
import { FeatureFlag, isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import * as queryString from 'query-string'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import * as events from '../../../events'
import {
  CellWrapper,
  FaqContainer,
  FAQTitle,
  FormContainer,
  HeroContainer,
  HeroImageWithURL,
  HowToDashContainer,
  HowToDashTitle,
  LandingContent,
  RenderBefore,
  SignUpDetailsWrapper,
  SlideFormContainer,
  ValuePropsWrapper,
  WhatIsDoorDashWrapper,
} from './styles'
import { throttle } from 'lodash'
import { LandingPage as Tag } from '../../../models/selectorAnchors'
import TextSection from '../../atoms/text-section'
import t from './strings'
import {
  AlreadyStartedEnum,
  AlreadyStartedSigningUpModalProps,
} from '../../../models/types'
import * as DA from '../../../typeModules/events'
import { Inset, StackChildren, Text } from '@doordash/design-language'
import { SlideDecks } from '../../../typeModules/slide'
import { setUtmSource } from '../../../utilities/utmSource'
import { getHamburgerItem, HamEnum } from '../../atoms/hamburger-menu'
import HowToDash, { howToDashSlides } from '../../atoms/how-to-dash'
import { TextType } from '../../atoms/text-section/text-section'
import { SimpleStyleType } from '../../templates/simple/constants'
import GetStarted from './components/GetStartedCTA'
import {
  FAQList,
  HEADER_HEIGHT_PX,
  SCROLL_THROTTLE_MS,
  SignUpDetailsText,
  SignUpDetailsTextJP,
  WhatIsDoorDashText,
} from './constants'
import CurrentHashElementScroller from '../../atoms/current-hash-element-scroller'

const PAYOUT_IMG = `${AWS_BASE}/img/dasher/payout.png`
const PAYOUT_BICYCLE_IMG = `${AWS_BASE}/img/dasher/payout-bicycle.png`

// Note (helen): This is a hack to use dasher acquisition bonuses in SEM ads
// Remove this when a more permanent solution comes around, see GROW-2582
const isDasherAcquisitionTest = (copy) => {
  return copy && copy.acquisition_test
}

const getTitle = (referrer, copy, guaranteedEarningsCampaign) => {
  if (guaranteedEarningsCampaign) {
    return geCampaignType.getSignupTitle(guaranteedEarningsCampaign)
  }
  if (isDasherAcquisitionTest(copy)) {
    return `Sign Up To Earn $${(
      referrer.referreeBonus / 100
    ).toLocaleString()}!`
  }
  return referrer.name
    ? `You've been referred by ${referrer.name}!`
    : t.referrerNameAlt()
}

const getReferralMessage = (referrer, copy) => {
  if (referrer) {
    const targetNumDeliveries = parseInt(referrer.targetNumDeliveries, 10)

    // Format so that a referreeBonus of 10000 will display as $100
    // but a referreeBonus of 21250 will display as $212.50
    let referreeBonus = (referrer.referreeBonus / 100).toString()
    if (referreeBonus.indexOf('.') !== -1) {
      referreeBonus = Number(referreeBonus).toFixed(2)
    }

    if (!isDasherAcquisitionTest(copy)) {
      if (targetNumDeliveries > 0 && Number(referreeBonus) > 0) {
        const referralMessage = referrer.name
          ? `Do ${targetNumDeliveries} deliveries by ` +
            `${referrer.referralExpiration} for a ` +
            `$${referreeBonus} referral bonus!`
          : ''
        return referralMessage
      }
    }
  }
  return ''
}

type DetailSignupPageProps = {
  referrer: any
  dasherApplyPageContent: any
  guaranteedEarningsCampaign: geCampaignType.GECampaign
  submitDasherApplication: any
  dismissGuaranteedEarningsRedirectModal: any
  dasherApplySubmittingApplication: boolean
  guaranteedEarningsRedirectModal: any
  applicantUniqueLink: string | null
  trackDasherApplyPageView: () => Promise<any>
  loadDasher: () => Promise<any>
  toggleAlreadyStartedSigningUpModal: (
    data?: AlreadyStartedSigningUpModalProps
  ) => Promise<any>
  trackLandingPageFAQ: (data: DA.LandingPageFAQ) => Promise<any>
  country: string
}

type ApplyPageState = {
  selectedIndex: boolean[]
  hasViewedReturnModal: boolean
}

const Cell = ({ isToggled, ...props }) => {
  return (
    <ListCell
      accessibilityRole="checkbox"
      accessibilityLabel={props.title}
      titleMaxLines={6}
      subtextMaxLines={1}
      isToggled={isToggled}
      iconEnd={
        isToggled
          ? { type: ListCell.IconTypes.ChevronUp }
          : { type: ListCell.IconTypes.ChevronDown }
      }
      renderBelowContent={() =>
        isToggled && (
          <Text styles={Text.Styles.ContentBody}>
            <Interpolate
              i18n={i18n}
              i18nKey={props.bodytext}
              components={[<br />]}
            />
          </Text>
        )
      }
      renderBeforeContent={() => <RenderBefore />}
      {...props}
    />
  )
}

/**
 * Renders a page which allows dashers to begin signing up for an account,
 * and displays additional information about being a dasher.
 *
 * Historically was known as the 'LandingPage' component.
 */
export class DetailSignupPage extends React.Component<
  DetailSignupPageProps & RouteComponentProps
> {
  public state = {
    // tslint:disable-next-line:prefer-array-literal
    selectedIndex: new Array(FAQList.length).fill(false),
    hasViewedReturnModal: false,
    showGetStarted: false,
    scrollHeight: 0,
  }

  public componentDidMount() {
    const { trackDasherApplyPageView, loadDasher } = this.props
    trackDasherApplyPageView()
    loadDasher()
    setUtmSource(queryString.parse(window.location.search))

    window.addEventListener(
      'scroll',
      throttle(this.handleScroll, SCROLL_THROTTLE_MS)
    )
  }

  public componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll)
  }

  public handleScroll = (e) => {
    const el = e.target.documentElement
    const GET_STARTED_VISIBLE_TARGET_HEIGHT = 540

    this.setState({
      showGetStarted: el.scrollTop > GET_STARTED_VISIBLE_TARGET_HEIGHT,
      scrollHeight: window.scrollY,
    })
  }

  public handleFAQClick = (index) => {
    const { trackLandingPageFAQ } = this.props

    // Toggles the FAQ components
    this.setState(
      (prevState: ApplyPageState) => ({
        selectedIndex: prevState.selectedIndex.map((el, clickedCell) =>
          clickedCell === index ? !el : el
        ),
      }),
      () => {
        trackLandingPageFAQ({
          action: DA.EventActions.Clicked,
          name: this.state.selectedIndex[index]
            ? DA.FAQNames.Opened
            : DA.FAQNames.Closed,
          faqTitle: FAQList[index].title,
        })
      }
    )
  }

  private shouldHideMobileIcons = () => {
    const { location } = this.props

    if (location) {
      const queryParams = queryString.parse(location.search)
      return queryParams.source === IOS_SIGNUP_SOURCE_PARAM
    }

    return false
  }

  public getSignUpCountry(country) {
    const currentLanguage = i18n.getCurrentLocale()
    const isJP =
      currentLanguage === 'ja' ||
      currentLanguage === 'ja-JP' ||
      country === COUNTRY_SHORTCODES.JP

    const isAU =
      currentLanguage === 'en-AU' || country === COUNTRY_SHORTCODES.AU

    const isCA =
      currentLanguage === 'fr-CA' ||
      currentLanguage === 'en-CA' ||
      country === COUNTRY_SHORTCODES.CA

    const isDE = country === COUNTRY_SHORTCODES.DE
    return { isJP, isAU, isCA, isDE }
  }

  public render() {
    const {
      referrer,
      dasherApplyPageContent,
      guaranteedEarningsCampaign,
      guaranteedEarningsRedirectModal,
      dismissGuaranteedEarningsRedirectModal,
      submitDasherApplication,
      dasherApplySubmittingApplication,
      toggleAlreadyStartedSigningUpModal,
      applicantUniqueLink,
      country,
    } = this.props

    const { hasViewedReturnModal, showGetStarted, scrollHeight } = this.state

    const title = getTitle(
      referrer,
      dasherApplyPageContent.copy,
      guaranteedEarningsCampaign
    )

    const referralMessage = getReferralMessage(
      referrer,
      dasherApplyPageContent.copy
    )

    if (
      isFeatureFlagEnabled(Exp.RETURN_TO_APPLICATION_AUTO) &&
      !hasViewedReturnModal
    ) {
      if (applicantUniqueLink) {
        this.setState({ hasViewedReturnModal: true })
        toggleAlreadyStartedSigningUpModal({
          isShowing: true,
          type: AlreadyStartedEnum.LoggedIn,
        })
      }
    }

    const currentSignUpCountry = this.getSignUpCountry(country)

    return (
      <Simple
        headerIsDark={scrollHeight <= HEADER_HEIGHT_PX}
        type={SimpleStyleType.Landing}
        shouldHideMobileIcons={this.shouldHideMobileIcons()}
      >
        <CurrentHashElementScroller />
        <LandingContent>
          {guaranteedEarningsRedirectModal && (
            <GuaranteedEarningsRedirectModal
              dismissGuaranteedEarningsRedirectModal={
                dismissGuaranteedEarningsRedirectModal
              }
              guaranteedEarningsRedirectModal={guaranteedEarningsRedirectModal}
              submitDasherApplication={submitDasherApplication}
              dasherApplySubmittingApplication={
                dasherApplySubmittingApplication
              }
            />
          )}
          {isFeatureFlagEnabled(Exp.DX_CRO_LP_GRADUATION_Q3_2020) ||
          currentSignUpCountry.isJP ? (
            <HeroContainer>
              {currentSignUpCountry.isJP ? (
                <HeroImageWithURL url={PAYOUT_BICYCLE_IMG} />
              ) : (
                <HeroImageWithURL url={PAYOUT_IMG} />
              )}
              <SlideFormContainer size={Inset.Sizes.XxxLarge}>
                <SignupForm
                  isContained
                  title={title}
                  referralSubtitle={referralMessage}
                  currentSignUpCountry={currentSignUpCountry}
                />
              </SlideFormContainer>
            </HeroContainer>
          ) : (
            <div>
              <HeaderSection
                alignChildren={referrer.name ? 'bottom' : 'center'}
                dasherApplyPageContent={dasherApplyPageContent}
                referrer={referrer}
                guaranteedEarningsCampaign={guaranteedEarningsCampaign}
              />
              <FormContainer>
                <SignupForm
                  isContained
                  title={title}
                  referralSubtitle={referralMessage}
                  currentSignUpCountry={currentSignUpCountry}
                />
              </FormContainer>
            </div>
          )}
          <FeatureFlag
            on={() => (
              <WhatIsDoorDashWrapper>
                <TextSection
                  title={t.whatIsDoorDashTitle()}
                  text={WhatIsDoorDashText}
                  style={{ maxWidth: '768px' }}
                  center={true}
                />
              </WhatIsDoorDashWrapper>
            )}
            flagName={Exp.DX_CRO_LP_GRADUATION_Q1_2020}
          />

          <ValuePropsWrapper
            data-anchor-id={Tag.ValueProps}
            id={getHamburgerItem(HamEnum.WhyDoorDash).anchor}
          >
            <ValueProps
              maxNumToRender={
                isFeatureFlagEnabled(Exp.DX_CRO_LP_GRADUATION_Q1_2020) ? 6 : 3
              }
            />
          </ValuePropsWrapper>

          <FeatureFlag
            on={() => (
              <SignUpDetailsWrapper
                id={getHamburgerItem(HamEnum.SignUpDetails).anchor}
              >
                <TextSection
                  title={t.signUpDetailsTitle()}
                  type={TextType.List}
                  text={
                    currentSignUpCountry.isJP
                      ? SignUpDetailsTextJP
                      : SignUpDetailsText
                  }
                  style={{ maxWidth: '768px', width: '100%' }}
                />
              </SignUpDetailsWrapper>
            )}
            flagName={Exp.DX_CRO_LP_GRADUATION_Q1_2020}
          />

          <FeatureFlag
            on={() => (
              <HowToDashContainer
                id={getHamburgerItem(HamEnum.HowToDash).anchor}
                size={StackChildren.Sizes.None}
              >
                <HowToDashTitle styles={Text.Styles.MajorPageTitle} tag="h2">
                  {t.howToDash()}
                </HowToDashTitle>
                <HowToDash
                  slides={howToDashSlides}
                  deck={SlideDecks.HowToDashSlideDeck}
                />
              </HowToDashContainer>
            )}
            flagName={Exp.DX_CRO_LP_GRADUATION_Q1_2020}
          />

          <FaqContainer
            data-anchor-id={Tag.FAQContainer}
            id={getHamburgerItem(HamEnum.FAQ).anchor}
          >
            <StackChildren>
              <FAQTitle
                styles={Text.Styles.MajorPageTitle}
                tag="h2"
                data-anchor-id={Tag.FAQTitle}
              >
                FAQ
              </FAQTitle>
              {FAQList.map((faq, index) => (
                <CellWrapper
                  key={index}
                  data-anchor-id={`${Tag.FAQCell}__${index}`}
                >
                  <Cell
                    isToggled={this.state.selectedIndex[index] === true}
                    onClick={() => this.handleFAQClick(index)}
                    isSeparatorVisible={false}
                    title={faq.title}
                    bodytext={faq.description}
                  />
                </CellWrapper>
              ))}
            </StackChildren>
          </FaqContainer>
          {showGetStarted &&
            isFeatureFlagEnabled(Exp.DX_CRO_LP_GRADUATION_Q1_2020) && (
              <GetStarted />
            )}
        </LandingContent>
      </Simple>
    )
  }
}

const mapStateToProps = (state) => ({
  referrer: state.referrer,
  dasherApplyPageContent: state.dasherApplyPageContent,
  guaranteedEarningsCampaign: state.guaranteedEarningsCampaign,
  guaranteedEarningsRedirectModal: state.guaranteedEarningsRedirectModal,
  dasherApplySubmittingApplication: state.dasherApplySubmittingApplication,
  applicantUniqueLink: state.applicantUniqueLink,
  country: state.country,
})

const mapDispatchToProps = {
  trackDasherApplyPageView: events.trackDasherApplyPageView,
  dismissGuaranteedEarningsRedirectModal:
    actions.dismissGuaranteedEarningsRedirectModal,
  submitDasherApplication: actions.submitDasherApplication,
  loadDasher: actions.loadDasher,
  toggleAlreadyStartedSigningUpModal:
    actions.toggleAlreadyStartedSigningUpModal,
  trackLandingPageFAQ: events.trackLandingPageFAQ,
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DetailSignupPage)
)
